module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_32.5b5ad03d.png";